//@ts-check
import React from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import { useDashboardState, useDashboardDispatch } from '../../context/dashboardContext';
import { selectWidget } from '../../context/selectors/widgetsSelector';
import ToggleIcon from '../../components/ToggleIcon';
import ChartProperties from './ChartProperties';
import TableProperties from './TableProperties';
import GaugeProperties from './GaugeProperties';
import Utils from '../../../../../../utils';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    disabledText: {
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'ECSidebarProperties'
});

var SidebarProperties = function SidebarProperties(_ref) {
  var selectedWidgetId = _ref.selectedWidgetId;
  var classes = useStyles({});
  var dashboardState = useDashboardState();
  var dashboardDispatch = useDashboardDispatch();
  var selectedWidget = selectWidget(dashboardState.content, selectedWidgetId);

  if (selectedWidget === null) {
    return React.createElement(Box, {
      px: 3,
      py: 2
    }, React.createElement(Typography, {
      variant: "h6"
    }, "Properties"), React.createElement(Typography, {
      className: classes.disabledText
    }, "There are no properties for selected item"));
  }

  var cube = dashboardState.content.dashboard.cubes.find(function (cube) {
    return cube.id === selectedWidget.source;
  });
  return React.createElement(Box, {
    px: 3,
    py: 2
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, Utils.formatting.camelCaseToWords(selectedWidget.elementName))), React.createElement(Grid, {
    item: true
  }, React.createElement(ToggleIcon, {
    type: "delete",
    onClick: function onClick() {
      return dashboardDispatch({
        type: 'remove_widget',
        payload: selectedWidgetId
      });
    }
  })))), React.createElement(Grid, {
    item: true
  }, (selectedWidget.elementName === 'pieChart' || selectedWidget.elementName === 'columnChart' || selectedWidget.elementName === 'barChart' || selectedWidget.elementName === 'lineChart') && React.createElement(ChartProperties, {
    selectedWidget: selectedWidget,
    cube: cube,
    dispatch: dashboardDispatch
  }), selectedWidget.elementName === 'table' && React.createElement(TableProperties, {
    selectedWidget: selectedWidget,
    cube: cube,
    dispatch: dashboardDispatch
  }), selectedWidget.elementName === 'circularGauge' && React.createElement(GaugeProperties, {
    selectedWidget: selectedWidget,
    cube: cube,
    dispatch: dashboardDispatch
  }))))));
};

export default SidebarProperties;